import http from './http'

export default {
    all() {
        return http.get('red')
    }
}